module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("Dedicated to:")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("Kerry Conroy my sister")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("Peter my husband")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("In loving memory of:")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("Ethel Curnow née Stephen")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("Carlyle Stephen")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("Grace Vincent née Holland")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_vm._v("Jack Holland")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e332cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 75
// module chunks = 0